// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__nUaoe","search":"Settings_search__3fdVX","filter":"Settings_filter__1fz8w"};